import request from "@/utils/request";

// 上传文件
export function upLoadFile(data) {
    return request({
        url: '/system/file/upload',
        method: 'POST',
        timeout: 60 * 60 * 1000,
        data: data,
    });
}

// 获取自建 ticket
export function getTicket() {
    return request({
        url: '/getJsapiTicket',
        method: 'POST'
    });
}
